export default __webpack_public_path__ + "static/media/input-check.13a6e354.svg";